export default __webpack_public_path__ + "static/media/Kumo-Regular.5a40717c.ttf";